import React from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const EmptyState = ({ onAddTalent }) => {
  return (
    <div className="bg-card rounded-xl border border-border p-12 text-center">
      <div className="flex justify-center mb-6">
        <div className="flex items-center justify-center w-16 h-16 bg-muted rounded-xl">
          <Icon name="Users" className="text-muted-foreground" size={32} />
        </div>
      </div>
      
      <h3 className="text-xl font-semibold text-foreground mb-2">
        No Talent Profiles Found
      </h3>
      
      <p className="text-muted-foreground mb-6 max-w-md mx-auto">
        Get started by adding your first talent profile. You can track their information, 
        assignments, and social media presence all in one place.
      </p>
      
      <Button 
        onClick={onAddTalent}
        className="flex items-center space-x-2"
      >
        <Icon name="Plus" size={18} />
        <span>Add First Talent</span>
      </Button>
    </div>
  );
};

export default EmptyState;